import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/modeloTarea/importer/modeloTareaImporterActions';

export default importerReducers(actions);
